import { cn, tv } from "@pcln/horizon";
import { MULTI_DESTINATION, ROUND_TRIP } from "./constants.js";
const flightTypeVariants = {
    multiDestination: {
        gridContainer: 'sm:grid-cols-3',
        flightTypeWrapper: 'sm:[grid-area:unset]'
    },
    oneWay: {
        gridContainer: [
            'sm:grid-cols-6 lg:grid-cols-[1fr_1fr_1fr_1fr_max-content]',
            "lg:[grid-template-areas:'options_options_options_options_options'_'origin_destination_timeline_passengers_submit'_'deals_deals_deals_deals_deals']",
            "sm:[grid-template-areas:'options_options_options_options_options_options'_'origin_origin_origin_destination_destination_destination'_'timeline_timeline_passengers_passengers_cabin_cabin'_'submit_submit_submit_submit_submit_submit']"
        ],
        flightTypeWrapper: 'sm:[grid-area:options]'
    },
    oneWayNoCabin: {
        gridContainer: [
            'sm:grid-cols-6 lg:grid-cols-[1fr_1fr_1fr_1fr_max-content]',
            "lg:[grid-template-areas:'options_options_options_options_options'_'origin_destination_timeline_passengers_submit'_'deals_deals_deals_deals_deals']",
            "sm:[grid-template-areas:'options_options_options_options_options_options'_'origin_origin_origin_destination_destination_destination'_'timeline_timeline_timeline_passengers_passengers_passengers'_'submit_submit_submit_submit_submit_submit']"
        ],
        flightTypeWrapper: 'sm:[grid-area:options]'
    },
    roundTrip: {
        gridContainer: [
            'sm:grid-cols-6 lg:grid-cols-[1fr_1fr_1fr_1fr_max-content]',
            "lg:[grid-template-areas:'options_options_options_options_options'_'origin_destination_timeline_passengers_submit'_'deals_deals_deals_deals_deals']",
            "sm:[grid-template-areas:'options_options_options_options_options_options'_'origin_origin_origin_destination_destination_destination'_'timeline_timeline_passengers_passengers_cabin_cabin'_'deals_deals_deals_submit_submit_submit']"
        ],
        flightTypeWrapper: 'sm:[grid-area:options]'
    },
    roundTripNoCabin: {
        gridContainer: [
            'sm:grid-cols-6 lg:grid-cols-[1fr_1fr_1fr_1fr_max-content]',
            "lg:[grid-template-areas:'options_options_options_options_options'_'origin_destination_timeline_passengers_submit'_'deals_deals_deals_deals_deals']",
            "sm:[grid-template-areas:'options_options_options_options_options_options'_'origin_origin_origin_destination_destination_destination'_'timeline_timeline_timeline_passengers_passengers_passengers'_'deals_deals_deals_submit_submit_submit']"
        ],
        flightTypeWrapper: 'sm:[grid-area:options]'
    },
    multiDestinationCompact: {
        gridContainer: 'sm:grid-cols-3',
        flightTypeWrapper: 'sm:[grid-area:unset]'
    },
    oneWayCompact: {
        gridContainer: [
            'sm:grid-cols-6',
            "sm:[grid-template-areas:'options_options_options_options_options_options'_'origin_origin_origin_destination_destination_destination'_'timeline_timeline_passengers_passengers_cabin_cabin'_'._._._submit_submit_submit']"
        ],
        flightTypeWrapper: 'sm:[grid-area:options]'
    },
    oneWayNoCabinCompact: {
        gridContainer: [
            'sm:grid-cols-6',
            "sm:[grid-template-areas:'options_options_options_options_options_options'_'origin_origin_origin_destination_destination_destination'_'timeline_timeline_timeline_passengers_passengers_passengers'_'._._._submit_submit_submit']"
        ],
        flightTypeWrapper: 'sm:[grid-area:options]'
    },
    roundTripCompact: {
        gridContainer: [
            'sm:grid-cols-6',
            "sm:[grid-template-areas:'options_options_options_options_options_options'_'origin_origin_origin_destination_destination_destination'_'timeline_timeline_passengers_passengers_cabin_cabin'_'deals_deals_deals_submit_submit_submit']"
        ],
        flightTypeWrapper: 'sm:[grid-area:options]'
    },
    roundTripNoCabinCompact: {
        gridContainer: [
            'sm:grid-cols-6',
            "sm:[grid-template-areas:'options_options_options_options_options_options'_'origin_origin_origin_destination_destination_destination'_'timeline_timeline_timeline_passengers_passengers_passengers'_'deals_deals_deals_submit_submit_submit']"
        ],
        flightTypeWrapper: 'sm:[grid-area:options]'
    }
};
const isMultiDestinationVariants = {
    true: {
        passengersInput: 'sm:[grid-area:unset]',
        cabinInput: 'sm:[grid-area:unset]'
    },
    false: {
        passengersInput: 'sm:[grid-area:passengers]',
        cabinInput: 'sm:[grid-area:cabin]'
    }
};
const flightFormSlots = {
    gridContainer: 'grid grid-cols-1 gap-3 items-center mx-auto',
    flightTypeWrapper: [
        'lg:h-9 text-nowrap lg:[grid-area:auto/1/auto/-1] w-max grid gap-4',
        'grid-cols-[max-content_max-content] items-center [grid-area:unset]'
    ],
    inputBase: '[grid-area:unset] ',
    originInput: '[grid-area:unset] sm:[grid-area:origin]',
    destinationInput: '[grid-area:unset] sm:[grid-area:destination]',
    timelineInput: '[grid-area:unset] sm:[grid-area:timeline] ',
    passengersInput: '[grid-area:unset] ',
    cabinInput: '[grid-area:unset]',
    multiDestDateWrapper: '',
    packageDeals: 'gap-2 text-sm [grid-area:unset] sm:[grid-area:deals]',
    packageDealsNonCompact: 'flex flex-row items-center justify-start gap-2 text-sm [grid-area:unset] sm:[grid-area:deals] lg:[grid-area:auto/1/auto/-1] lg:order-last'
};
const horizonFlightForm = tv({
    slots: flightFormSlots,
    variants: {
        flightType: flightTypeVariants,
        isMultiDestination: isMultiDestinationVariants
    },
    defaultVariants: {
        flightType: 'oneWay',
        isMultiDestination: false
    }
});
const getFlightTypeVariant = (flightType, hideCabin, variant = 'full')=>{
    if ('compact' === variant) {
        if (flightType === MULTI_DESTINATION) return 'multiDestinationCompact';
        if (flightType === ROUND_TRIP) return hideCabin ? 'roundTripNoCabinCompact' : 'roundTripCompact';
        return hideCabin ? 'oneWayNoCabinCompact' : 'oneWayCompact';
    }
    if (flightType === MULTI_DESTINATION) return 'multiDestination';
    if (flightType === ROUND_TRIP) return hideCabin ? 'roundTripNoCabin' : 'roundTrip';
    return hideCabin ? 'oneWayNoCabin' : 'oneWay';
};
const getGridContainerClass = (flightType, addHotel, hideCabin = false, variant = 'full')=>{
    const flightTypeVariant = getFlightTypeVariant(flightType, hideCabin, variant);
    const isMultiDestination = flightType === MULTI_DESTINATION;
    const styles = horizonFlightForm({
        flightType: flightTypeVariant,
        isMultiDestination
    });
    return cn(styles.gridContainer(), addHotel ? 'with-hotel' : 'without-hotel', flightType.toLowerCase());
};
const getFlightTypeClass = (flightType)=>{
    const flightTypeVariant = getFlightTypeVariant(flightType, false);
    const isMultiDestination = flightType === MULTI_DESTINATION;
    const styles = horizonFlightForm({
        flightType: flightTypeVariant,
        isMultiDestination
    });
    return styles.flightTypeWrapper();
};
const getInputClass = (type, flightType = 'OW', variant = 'full')=>{
    const isMultiDestination = flightType === MULTI_DESTINATION;
    const styles = horizonFlightForm({
        isMultiDestination
    });
    if ('packageDeals' === type) return 'compact' === variant ? flightFormSlots.packageDeals : flightFormSlots.packageDealsNonCompact;
    const inputMap = {
        origin: styles.originInput,
        destination: styles.destinationInput,
        timeline: styles.timelineInput,
        passengers: styles.passengersInput,
        cabin: styles.cabinInput,
        multiDestDateWrapper: ()=>flightFormSlots.multiDestDateWrapper
    };
    const baseClass = inputMap[type]();
    if ('cabin' === type && 'compact' !== variant) return cn(baseClass, 'lg:hidden');
    return baseClass;
};
export { getFlightTypeClass, getGridContainerClass, getInputClass, horizonFlightForm };
